export { MPUMALANGA_COORDS } from './mpumalangaCoords';
export { DEFAULT_MAP_CENTER } from './mapCenter';
